import { render, staticRenderFns } from "./disclosureModal.vue?vue&type=template&id=10a519dd"
import script from "./disclosureModal.vue?vue&type=script&lang=js"
export * from "./disclosureModal.vue?vue&type=script&lang=js"
import style0 from "./disclosureModal.vue?vue&type=style&index=0&id=10a519dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports